// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReviewItem_modal__AJg23","modal-content":"ReviewItem_modal-content__bxm5n","review":"ReviewItem_review__6puII"};